import { render, staticRenderFns } from "./WorkoutBlock.vue?vue&type=template&id=54c27d70&"
import script from "./WorkoutBlock.vue?vue&type=script&lang=js&"
export * from "./WorkoutBlock.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports